"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDependentFields = undefined;

var _actions = require("egov-ui-kit/redux/form/actions");

var setDependentFields = exports.setDependentFields = function setDependentFields(fields, dispatch, formKey, isEnabled) {
  var propertyId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "hideField";
  return fields.forEach(function (fieldName) {
    dispatch((0, _actions.setFieldProperty)(formKey, fieldName, propertyId, isEnabled));
  });
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPay/utils/enableDependentFields.js
// module id = ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPay/utils/enableDependentFields.js
// module chunks = 504